import { render } from "./pro-img.vue?vue&type=template&id=38f966c7&scoped=true"
import script from "./pro-img.vue?vue&type=script&lang=js"
export * from "./pro-img.vue?vue&type=script&lang=js"

import "./pro-img.vue?vue&type=style&index=0&id=38f966c7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-38f966c7"

export default script